'use client'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { TimePicker } from '@mui/x-date-pickers'
import { format, parse, isValid } from 'date-fns'
import { FieldValue } from '@/types'
import { memo } from 'react'

type TimeFieldProps = {
  id: string
  value: FieldValue
  isHidden: boolean
  onChangeHandler: (val: FieldValue, id: string) => void
}

const TimeField = ({ id, value, isHidden, onChangeHandler }: TimeFieldProps) => {
  const parseTimeString = (timeStr: string) => {
    try {
      // Try parsing with different formats
      const formats = ['hh:mm a', 'HH:mm', 'h:mm a', 'H:mm']
      for (const formatStr of formats) {
        const parsedTime = parse(timeStr, formatStr, new Date())
        if (isValid(parsedTime)) {
          return parsedTime
        }
      }
      // If no format matches, return null
      return null
    } catch (error) {
      return null
    }
  }

  const getDefaultTime = () => {
    const now = new Date()
    now.setHours(0, 0, 0, 0)
    return now
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        disabled={isHidden}
        timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
        value={value ? parseTimeString(value as string) || getDefaultTime() : getDefaultTime()}
        onChange={(value) => {
          if (value && isValid(value)) {
            onChangeHandler(format(value, 'hh:mm a'), id)
          }
        }}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
          },
        }}
      />
    </LocalizationProvider>
  )
}

export default memo(TimeField)
